/**
 * Member kind discriminant — determines what happens when a card row is tapped.
 *
 * - ROUTE: navigate to a URL via React Router.
 * - ACTION: invoke an onAction callback (open a sheet, palette, etc.).
 */
export const NAV_MEMBER_KIND = {
  ROUTE: 'route',
  ACTION: 'action',
};

/**
 * Nav IDs (from `selectNavigationConfig`) that belong to the Home group, in display order.
 * The first one present for a given user (always Home itself) is the primary destination.
 * Dashboards and Reports are the expansion members shown only when the card opens.
 */
export const HOME_GROUP_MEMBER_IDS = ['home', 'dashboards', 'reports'];

/**
 * Long-press threshold (ms) before the speed-dial card opens.
 * Mirrors the mockup's 300 ms value.
 */
export const LONG_PRESS_DELAY_MS = 300;

/**
 * Haptic vibration duration (ms) fired on long-press (Web Vibration API).
 * Matches the mockup's `navigator.vibrate(9)`.
 */
export const LONG_PRESS_VIBRATION_MS = 9;

/**
 * Opacity of the indigo glow ring around the held tab's icon wrapper.
 */
export const NAV_HELD_GLOW_ALPHA = 0.16;

/**
 * Opacity of the indigo outer shadow on the held tab's icon.
 */
export const NAV_HELD_SHADOW_ALPHA = 0.45;

/**
 * Opacity of the scrim that dims the app content while a card is open.
 */
export const NAV_SCRIM_ALPHA = 0.28;

/**
 * Opacity of the frosted-glass card background (~0.86 per mockup).
 */
export const NAV_CARD_BG_ALPHA = 0.86;

/**
 * Card entry spring easing — cubic-bezier(.16,1.1,.3,1) matching the mockup.
 */
export const NAV_CARD_SPRING = 'cubic-bezier(0.16, 1.1, 0.3, 1)';
